"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAdminFlag = exports.removeUserRole = exports.removeResourceFromGroup = exports.removeGroupMember = exports.removeGroup = exports.modifyUserRoles = exports.hasPermission = exports.group56 = exports.grantRoleToPrincipal = exports.getUserPermissionsForResourceType = exports.getRoles = exports.getPrincipal = exports.getGroupInfo = exports.findPrincipals = exports.findGroups = exports.createGroup = exports.buildGroupUrlFromId = exports.addUserRole = exports.addResourceToGroup = exports.addGroupMember = exports.CoamClient = void 0;

var CoamClient = require('./CoamClient');

exports.CoamClient = CoamClient;

var _require = require('./coamHelpers'),
    getRoles = _require.getRoles,
    modifyUserRoles = _require.modifyUserRoles,
    removeUserRole = _require.removeUserRole,
    addUserRole = _require.addUserRole,
    grantRoleToPrincipal = _require.grantRoleToPrincipal,
    setAdminFlag = _require.setAdminFlag,
    createGroup = _require.createGroup,
    removeGroup = _require.removeGroup,
    findGroups = _require.findGroups,
    getGroupInfo = _require.getGroupInfo,
    addGroupMember = _require.addGroupMember,
    removeGroupMember = _require.removeGroupMember,
    group56 = _require.group56,
    buildGroupUrlFromId = _require.buildGroupUrlFromId,
    addResourceToGroup = _require.addResourceToGroup,
    removeResourceFromGroup = _require.removeResourceFromGroup,
    hasPermission = _require.hasPermission,
    getUserPermissionsForResourceType = _require.getUserPermissionsForResourceType,
    findPrincipals = _require.findPrincipals,
    getPrincipal = _require.getPrincipal;

exports.getPrincipal = getPrincipal;
exports.findPrincipals = findPrincipals;
exports.getUserPermissionsForResourceType = getUserPermissionsForResourceType;
exports.hasPermission = hasPermission;
exports.removeResourceFromGroup = removeResourceFromGroup;
exports.addResourceToGroup = addResourceToGroup;
exports.buildGroupUrlFromId = buildGroupUrlFromId;
exports.group56 = group56;
exports.removeGroupMember = removeGroupMember;
exports.addGroupMember = addGroupMember;
exports.getGroupInfo = getGroupInfo;
exports.findGroups = findGroups;
exports.removeGroup = removeGroup;
exports.createGroup = createGroup;
exports.setAdminFlag = setAdminFlag;
exports.grantRoleToPrincipal = grantRoleToPrincipal;
exports.addUserRole = addUserRole;
exports.removeUserRole = removeUserRole;
exports.modifyUserRoles = modifyUserRoles;
exports.getRoles = getRoles;